export function setPageTitle(text: string) {
    const node = document.querySelector("title")
    if (node) {
        node.innerText = text
    }
}
